/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SyncDeclarationDetailPayloadDto
 */
export interface SyncDeclarationDetailPayloadDto {
    /**
     * 
     * @type {string}
     * @memberof SyncDeclarationDetailPayloadDto
     */
    declarationName: string;
    /**
     * 
     * @type {string}
     * @memberof SyncDeclarationDetailPayloadDto
     */
    entityName: string;
    /**
     * 
     * @type {string}
     * @memberof SyncDeclarationDetailPayloadDto
     */
    country: string;
    /**
     * 
     * @type {string}
     * @memberof SyncDeclarationDetailPayloadDto
     */
    programOrder: string;
    /**
     * 
     * @type {string}
     * @memberof SyncDeclarationDetailPayloadDto
     */
    programOrderTotalPremium: string;
    /**
     * 
     * @type {Date}
     * @memberof SyncDeclarationDetailPayloadDto
     */
    dueDate: Date;
}

/**
 * Check if a given object implements the SyncDeclarationDetailPayloadDto interface.
 */
export function instanceOfSyncDeclarationDetailPayloadDto(value: object): value is SyncDeclarationDetailPayloadDto {
    if (!('declarationName' in value) || value['declarationName'] === undefined) return false;
    if (!('entityName' in value) || value['entityName'] === undefined) return false;
    if (!('country' in value) || value['country'] === undefined) return false;
    if (!('programOrder' in value) || value['programOrder'] === undefined) return false;
    if (!('programOrderTotalPremium' in value) || value['programOrderTotalPremium'] === undefined) return false;
    if (!('dueDate' in value) || value['dueDate'] === undefined) return false;
    return true;
}

export function SyncDeclarationDetailPayloadDtoFromJSON(json: any): SyncDeclarationDetailPayloadDto {
    return SyncDeclarationDetailPayloadDtoFromJSONTyped(json, false);
}

export function SyncDeclarationDetailPayloadDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SyncDeclarationDetailPayloadDto {
    if (json == null) {
        return json;
    }
    return {
        
        'declarationName': json['declarationName'],
        'entityName': json['entityName'],
        'country': json['country'],
        'programOrder': json['programOrder'],
        'programOrderTotalPremium': json['programOrderTotalPremium'],
        'dueDate': (new Date(json['dueDate'])),
    };
}

export function SyncDeclarationDetailPayloadDtoToJSON(json: any): SyncDeclarationDetailPayloadDto {
    return SyncDeclarationDetailPayloadDtoToJSONTyped(json, false);
}

export function SyncDeclarationDetailPayloadDtoToJSONTyped(value?: SyncDeclarationDetailPayloadDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'declarationName': value['declarationName'],
        'entityName': value['entityName'],
        'country': value['country'],
        'programOrder': value['programOrder'],
        'programOrderTotalPremium': value['programOrderTotalPremium'],
        'dueDate': ((value['dueDate']).toISOString()),
    };
}

